import React, { useEffect, useContext } from 'react'
import { injectIntl } from 'gatsby-plugin-intl';
import Context from '../context/ModalContext'
import AuthContext from '../context/AuthContext'

import styled from 'styled-components'
import { device } from "../device"

const DownloadLink = styled.a`
    position: relative;

    align-items: center;
    display: flex;
    height: 32px;
    justify-content: center;
    margin-top: 24px;
    padding: 0 24px;
    width: fit-content;

    background: var(--green1);
    color: var(--brand);
    border-radius: 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    line-height: 1px;
    transition: background .1s ease-in-out;
    &:hover {
        background: var(--green2);
        color: var(--brand);
    }
    @media ${device.lg} {
        padding: 0 32px 0 40px;
    }
    svg {
        left: 14px;
        top: 50%;
        position: absolute;
        display: none;
        transform: translate(0,-50%);
        @media ${device.lg} {
            display: block;
        }
    }
    @media ${device.sm} {
        margin-top: 0;
    }
`;

const DownloadButton = styled(DownloadLink)``;

const DownloadBtn = ({intl, href}) => {

    const loginContext = useContext(AuthContext);
    const authcontext = useContext(AuthContext);
    const setAuth = () => {
        loginContext.updateLoginMode();
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (localStorage.getItem('isLogin') === '1' && !authcontext.data.loginMode) {
                setAuth();
            }
        }
    });

    return (
        <>
            <AuthContext.Consumer>
                {(authcontext) => authcontext.data.loginMode ? 
                    <DownloadLink href={href} target="_blank" rel="noreferrer noopener">
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16">
                            <g fill="none" fillRule="evenodd" stroke="#181818">
                                <path strokeWidth="2" d="M7 6.111V0v6.111m4.813 0L7 11.611l-4.813-5.5m4.813 0V11 6.111z"/>
                                <path d="M0 15.5h14H0z"/>
                            </g>
                        </svg> */}
                        <span>{intl.formatMessage({ id: 'get' })}</span>
                    </DownloadLink>
                 : 
                    <Context.Consumer>
                        {context => (
                        <DownloadButton onClick={context.updateModalMode}>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16">
                                <g fill="none" fillRule="evenodd" stroke="#181818">
                                    <path strokeWidth="2" d="M7 6.111V0v6.111m4.813 0L7 11.611l-4.813-5.5m4.813 0V11 6.111z"/>
                                    <path d="M0 15.5h14H0z"/>
                                </g>
                            </svg>
                            <span>{intl.formatMessage({ id: 'get' })}</span> */}
                        </DownloadButton>
                        )}
                    </Context.Consumer>
                }
            </AuthContext.Consumer>
        </>
    )
};

export default injectIntl(DownloadBtn);